import { pgEnumFromObject } from '../../../functions/pgEnumFromObject';
import { EHR_INTEGRATION_STATUSES } from '../constants/EHR_INTEGRATION_STATUSES';

/**
 * @group Enums
@summary PostgreSQL enum for EHR integration status values

<blockquote>
PostgreSQL enum for tracking EHR integration linking status.
Used in ehr_integrations table to track OpenEMR patient creation state.
</blockquote>

@example
```typescript
const status: EhrIntegrationStatus = ehrIntegrationStatusEnum.enumValues[0];
// 'pending'
```
 * @internal
 */
export const ehrIntegrationStatusEnum = pgEnumFromObject(
  'ehr_integration_status',
  EHR_INTEGRATION_STATUSES
);
